import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class BlacklistService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/v2/all-blacklists', query);
  }

  create(body: any) {
    return this.post('/v2/post-blacklist', body);
  }

  update(updateBlacklist) {
    return this.put('/v2/update-blacklist', updateBlacklist);
  }

  delete(id) {
    return this.post('/v2/delete-blacklist/' + id);
  }

  deleteMulti(body: any) {
    return this.post('/v2/delete-multi-blacklist', body);
  }

  uploadAdd(body: any) {
    return this.post('/v2/upload-add-blacklist', body);
  }

  uploadDelete(body: any) {
    return this.post('/v2/upload-delete-blacklist', body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Blacklist.service.ts